module.exports = __webpack_public_path__ + "img/logo.30944f3c.png";